if (!window.mtScriptsCargado) {
  window.mtScriptsCargado = true;

  document.addEventListener('DOMContentLoaded', function () {
    initRevelado();
    initFaq();
    initGaleriaProducto();
    initVariantesProducto();
    initCantidadProducto();
    initLightbox();
  });
}

/* ---------------------------------------------------------------------
   Lightbox: clic en una foto marcada como zoomable la agranda en pantalla
   --------------------------------------------------------------------- */
function initLightbox() {
  var overlay = document.createElement('div');
  overlay.className = 'mt-lightbox';
  overlay.setAttribute('data-abierto', 'false');
  overlay.innerHTML =
    '<button type="button" class="mt-lightbox__cerrar" aria-label="Cerrar">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
    '</button>' +
    '<img class="mt-lightbox__img" src="" alt="">';
  document.body.appendChild(overlay);

  var imgLightbox = overlay.querySelector('.mt-lightbox__img');
  var botonCerrar = overlay.querySelector('.mt-lightbox__cerrar');

  function abrir(src, alt) {
    imgLightbox.setAttribute('src', src);
    imgLightbox.setAttribute('alt', alt || '');
    overlay.setAttribute('data-abierto', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  function cerrar() {
    overlay.setAttribute('data-abierto', 'false');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (evento) {
    var zoomable = evento.target.closest ? evento.target.closest('.mt-zoomable') : null;
    if (zoomable) {
      var full = zoomable.getAttribute('data-full') || zoomable.currentSrc || zoomable.src;
      abrir(full, zoomable.getAttribute('alt'));
      return;
    }
    if (evento.target === overlay || evento.target === botonCerrar || botonCerrar.contains(evento.target)) {
      cerrar();
    }
  });

  document.addEventListener('keydown', function (evento) {
    if (evento.key === 'Escape') cerrar();
  });
}

/* ---------------------------------------------------------------------
   Revelado al hacer scroll (aplica a cualquier .mt-reveal de la página)
   --------------------------------------------------------------------- */
function initRevelado() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  var prefiereReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefiereReducido) {
    elementos.forEach(function (el) {
      el.classList.add('mt-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el, indice) {
    el.style.setProperty('--mt-orden', indice % 8);
    observer.observe(el);

    // Respaldo: si por algún motivo el elemento nunca llega a revelarse
    // (por ejemplo, un bloque muy alto que nunca cruza el umbral, o un
    // fallo del observer), se fuerza su visibilidad a los pocos segundos
    // para que el contenido nunca quede invisible de forma permanente.
    setTimeout(function () {
      if (!el.classList.contains('mt-visible')) {
        el.classList.add('mt-visible');
        observer.unobserve(el);
      }
    }, 2500);
  });
}

/* ---------------------------------------------------------------------
   Acordeón de preguntas frecuentes
   --------------------------------------------------------------------- */
function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;

  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq-item__pregunta');
    var respuesta = item.querySelector('.mt-faq-item__respuesta');
    if (!boton || !respuesta) return;

    boton.addEventListener('click', function () {
      var estaAbierto = item.getAttribute('data-abierto') === 'true';

      items.forEach(function (otro) {
        otro.setAttribute('data-abierto', 'false');
        var otraRespuesta = otro.querySelector('.mt-faq-item__respuesta');
        if (otraRespuesta) otraRespuesta.style.maxHeight = null;
      });

      if (!estaAbierto) {
        item.setAttribute('data-abierto', 'true');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

/* ---------------------------------------------------------------------
   Galería de producto: clic en miniatura cambia la imagen principal
   --------------------------------------------------------------------- */
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;

  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = Array.prototype.slice.call(galeria.querySelectorAll('[data-mt-miniatura]'));
  var botonPrev = galeria.querySelector('[data-mt-galeria-prev]');
  var botonNext = galeria.querySelector('[data-mt-galeria-next]');
  if (!principal || !miniaturas.length) return;

  function activarMiniatura(miniatura) {
    var nuevaSrc = miniatura.getAttribute('data-src');
    var nuevoSrcset = miniatura.getAttribute('data-srcset');
    var nuevoFull = miniatura.getAttribute('data-full');
    var nuevoAlt = miniatura.getAttribute('data-alt') || '';

    if (nuevaSrc) principal.setAttribute('src', nuevaSrc);
    if (nuevoSrcset) principal.setAttribute('srcset', nuevoSrcset);
    if (nuevoFull) principal.setAttribute('data-full', nuevoFull);
    principal.setAttribute('alt', nuevoAlt);

    miniaturas.forEach(function (m) {
      m.setAttribute('data-activa', 'false');
    });
    miniatura.setAttribute('data-activa', 'true');
  }

  function irRelativo(desplazamiento) {
    var indiceActual = miniaturas.findIndex(function (m) {
      return m.getAttribute('data-activa') === 'true';
    });
    if (indiceActual === -1) indiceActual = 0;
    var siguiente = (indiceActual + desplazamiento + miniaturas.length) % miniaturas.length;
    activarMiniatura(miniaturas[siguiente]);
  }

  miniaturas.forEach(function (miniatura) {
    miniatura.addEventListener('click', function () {
      activarMiniatura(miniatura);
    });
  });

  if (botonPrev) botonPrev.addEventListener('click', function () { irRelativo(-1); });
  if (botonNext) botonNext.addEventListener('click', function () { irRelativo(1); });
}

/* ---------------------------------------------------------------------
   Selector de variantes: actualiza precio, id oculto y estado agotado
   --------------------------------------------------------------------- */
function initVariantesProducto() {
  var contenedor = document.querySelector('[data-mt-variantes]');
  if (!contenedor) return;

  var datosScript = contenedor.querySelector('[data-mt-variantes-json]');
  var selects = contenedor.querySelectorAll('[data-mt-opcion]');
  var inputId = document.querySelector('[data-mt-variant-id]');
  var precioActual = document.querySelector('[data-mt-precio-actual]');
  var precioAnterior = document.querySelector('[data-mt-precio-anterior]');
  var precioDescuento = document.querySelector('[data-mt-precio-descuento]');
  var botonAgregar = document.querySelector('[data-mt-agregar]');
  if (!datosScript || !selects.length || !inputId) return;

  var variantes;
  try {
    variantes = JSON.parse(datosScript.textContent);
  } catch (error) {
    return;
  }

  function formatearMoneda(centavos) {
    return (
      (window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(centavos, window.mt_money_format)
        : '$' + (centavos / 100).toFixed(0))
    );
  }

  function encontrarVariante() {
    var seleccion = Array.prototype.map.call(selects, function (s) {
      return s.value;
    });

    return variantes.find(function (variante) {
      return variante.options.every(function (valorOpcion, indice) {
        return valorOpcion === seleccion[indice];
      });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;

    inputId.value = variante.id;

    if (precioActual) precioActual.textContent = formatearMoneda(variante.price);

    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatearMoneda(variante.compare_at_price);
        precioAnterior.style.display = '';
        if (precioDescuento) {
          var porcentaje = Math.round(((variante.compare_at_price - variante.price) / variante.compare_at_price) * 100);
          precioDescuento.textContent = '-' + porcentaje + '%';
          precioDescuento.style.display = '';
        }
      } else {
        precioAnterior.style.display = 'none';
        if (precioDescuento) precioDescuento.style.display = 'none';
      }
    }

    if (botonAgregar) {
      if (variante.available) {
        botonAgregar.disabled = false;
        botonAgregar.textContent = botonAgregar.getAttribute('data-texto-disponible');
      } else {
        botonAgregar.disabled = true;
        botonAgregar.textContent = botonAgregar.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (select) {
    select.addEventListener('change', actualizar);
  });
}

/* ---------------------------------------------------------------------
   Selector de cantidad (+ / -)
   --------------------------------------------------------------------- */
function initCantidadProducto() {
  var contenedor = document.querySelector('[data-mt-cantidad]');
  if (!contenedor) return;

  var input = contenedor.querySelector('input');
  var menos = contenedor.querySelector('[data-mt-restar]');
  var mas = contenedor.querySelector('[data-mt-sumar]');
  if (!input || !menos || !mas) return;

  menos.addEventListener('click', function () {
    var valor = parseInt(input.value, 10) || 1;
    if (valor > 1) input.value = valor - 1;
  });

  mas.addEventListener('click', function () {
    var valor = parseInt(input.value, 10) || 1;
    input.value = valor + 1;
  });
}
